"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mempool_space_default_1 = __importDefault(require("./mempool-space-default"));
class BlockStream extends mempool_space_default_1.default {
    constructor(testnet = false) {
        const baseUrl = testnet
            ? "https://blockstream.info/testnet/api"
            : "https://blockstream.info/api";
        super(baseUrl);
    }
    getRecommendedFeeRate(speed = "normal") {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("not supported");
        });
    }
}
exports.default = BlockStream;
//# sourceMappingURL=blockstream.js.map